import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { List } from 'immutable';
import { bindActionCreators } from 'redux';

import Brand from 'models/brand';
import { PressRelease as PressReleaseModel } from 'models/press-release';

import PressRelease from 'components/press/press-release';
import GetInTouch from 'components/press/get-in-touch';

import sendContactInquiryCreator from 'action-creators/brand/send-contact-inquiry';

const propTypes = {
  brand: PropTypes.instanceOf(Brand).isRequired,
  sendContactInquiry: PropTypes.func.isRequired,
  pressRelease: PropTypes.instanceOf(PressReleaseModel).isRequired,
};

const defaultProps = {
  pressArticles: List(),
  pressReleases: List(),
};

const PressReleasePage = ({ brand, pressRelease, sendContactInquiry }) => (
  <Fragment>
    <PressRelease brand={brand} pressRelease={pressRelease} />
    <GetInTouch brand={brand} sendContactInquiry={sendContactInquiry} />
  </Fragment>
);

const mapStateToProps = (state) => {
  const {
    brand,
    pressRelease,
  } = state.brand;

  return {
    brand,
    pressRelease,
  };
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    sendContactInquiry: sendContactInquiryCreator,
  }, dispatch)
);

PressReleasePage.propTypes = propTypes;
PressReleasePage.defaultProps = defaultProps;
export default connect(mapStateToProps, mapDispatchToProps)(PressReleasePage);

